// 表格和图表组件
export default {
  // 表头统计
  totalRecords: "共计",
  records: "条数据",
  loading: "拼命加载中",

  // 表格列名
  blockchain: "公链",
  address: "地址",
  mainBalance: "主币余额",
  usdtBalance: "USDT余额",
  totalAsset: "总资产（USDT）",
  remark: "备注",
  assetBalanceChange: "总资产余额变化（近7天）",
  action: "操作",

  // 操作按钮
  delete: "删除",
  addRemark: "点击添加备注",
  loadMore: "加载更多数据(每次加载20条)",
  collapse: "收起",
  downloadDetails: "下载数据明细",

  // 空状态
  noData: "暂无数据",

  // 消息提示
  copySuccess: "复制成功",
  addressNotFound: "没有查出该地址",
  deleteConfirm: "是否删除此条地址?",
  deleteSuccess: "删除成功",
  deleteCancelled: "已取消删除",
  lastAddressWarning: "此地址为最后一条，不可删除",
  remarkSuccess: "备注修改成功",

  // 对话框
  tip: "删除确认",
  confirm: "确定",
  cancel: "取消",
  warning: "警告",

  // 下载文件名
  balanceData: "余额数据",
};
